<template>
  <div v-if="visible" class="tab-panel">
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Tab',
  props: {
    title: {
      default: 'Untitled',
      type: String
    },
    tabKey: String,
    active: {
      default: false,
      type: Boolean
    },
    content: [String, Number]
  },
  data: function() {
    return {
      visible: this.active
    }
  },
  methods: {
    show: function() {
      this.visible = true
    },
    hide: function() {
      this.visible = false
    }
  }
}
</script>
<style scoped>
.tab-panel {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  overflow-y: auto;
}
</style>
